// Mock data for tryHimandsee ministries website

export const ministryInfo = {
  name: "tryHimandsee ministries",
  tagline: "Freely ye have received, freely give",
  verse: "Matthew 10:8",
  mission: "Encouraging people to follow Christ and seek encounters with Him while serving the poor and underserved communities of Richmond and Henrico.",
  contact: {
    email: "tryHimandsee3.7@gmail.com",
    address: "Richmond, VA"
  }
};

export const services = [
  {
    id: 1,
    title: "The PEW Pantry",
    description: "Food given with dignity. Provide. Encourage. Witness - no questions asked.",
    icon: "UtensilsCrossed"
  },
  {
    id: 2,
    title: "Garments of Grace",
    description: "Quality clothing shared with hospitality. Clothed in dignity, covered in grace.",
    icon: "Shirt"
  },
  {
    id: 3,
    title: "Kingdom Care Hygiene Kits",
    description: "Essential personal-care items that uplift, strengthen, and affirm God-given worth.",
    icon: "Sparkles"
  },
  {
    id: 5,
    title: "Monthly Miracle Runs",
    description: "Random blessings, eternal impact. We go out monthly to bless 5–10 people through generosity, encouragement, and love.",
    icon: "Gift"
  },
  {
    id: 4,
    title: "Prayer & Spiritual Support",
    description: "Providing spiritual support and prayer to those seeking guidance and hope.",
    icon: "Heart"
  }
];

export const encounters = [
  {
    id: 1,
    title: "Weekly Encounter Nights",
    description: "Join us every Friday at 7 PM for powerful worship, prayer, and seeking the presence of God.",
    schedule: "Fridays, 7:00 PM"
  },
  {
    id: 2,
    title: "Prayer Gatherings",
    description: "Morning prayer sessions where we intercede for our community, nation, and those in need.",
    schedule: "Tuesdays, 6:00 AM"
  },
  {
    id: 3,
    title: "Encounter Conference",
    description: "Annual multi-day conference focused on deep worship, prophetic ministry, and life transformation.",
    schedule: "Coming Spring 2026"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    text: "This ministry provided food when my family had nothing. But more than that, they showed us God's love and gave us hope.",
    role: "Community Member"
  },
  {
    id: 2,
    name: "David R.",
    text: "The Encounter nights changed my life. I came broken and left with a renewed faith and purpose.",
    role: "Volunteer"
  },
  {
    id: 3,
    name: "Jennifer L.",
    text: "Serving with tryHimandsee has been the most rewarding experience. Seeing God work through us is incredible.",
    role: "Ministry Partner"
  }
];

export const volunteerOpportunities = [
  {
    id: 1,
    title: "Food Distribution Team",
    description: "Help organize and distribute food to families every Saturday morning.",
    commitment: ""
  },
  {
    id: 2,
    title: "Clothing Sorter",
    description: "Sort, organize, and prepare clothing donations for distribution.",
    commitment: ""
  },
  {
    id: 4,
    title: "Prayer Team",
    description: "Join our dedicated prayer warriors interceding for the ministry and community.",
    commitment: ""
  }
];

export const prayerRequests = [
  {
    id: 1,
    name: "Anonymous",
    request: "Please pray for healing and restoration in my family.",
    date: "2025-12-10"
  },
  {
    id: 2,
    name: "Michael T.",
    request: "Praying for provision and a new job opportunity.",
    date: "2025-12-09"
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Community Food Drive",
    date: "December 21, 2025",
    time: "10:00 AM - 2:00 PM",
    location: "Richmond Community Center"
  },
  {
    id: 2,
    title: "Encounter Night: Year End Celebration",
    date: "December 27, 2025",
    time: "7:00 PM",
    location: "Ministry Center"
  },
  {
    id: 3,
    title: "New Year Prayer & Fasting",
    date: "January 1-7, 2026",
    time: "Various Times",
    location: "Online & In-Person"
  }
];
